import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\UpdateInvoiceStatusTagController::__invoke
* @see app/Http/Controllers/Invoice/UpdateInvoiceStatusTagController.php
* @route '/api/invoicing/{invoice}/status-tag'
*/
const UpdateInvoiceStatusTagController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoiceStatusTagController.url(args, options),
    method: 'put',
})

UpdateInvoiceStatusTagController.definition = {
    methods: ["put"],
    url: '/api/invoicing/{invoice}/status-tag',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Invoice\UpdateInvoiceStatusTagController::__invoke
* @see app/Http/Controllers/Invoice/UpdateInvoiceStatusTagController.php
* @route '/api/invoicing/{invoice}/status-tag'
*/
UpdateInvoiceStatusTagController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return UpdateInvoiceStatusTagController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\UpdateInvoiceStatusTagController::__invoke
* @see app/Http/Controllers/Invoice/UpdateInvoiceStatusTagController.php
* @route '/api/invoicing/{invoice}/status-tag'
*/
UpdateInvoiceStatusTagController.put = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoiceStatusTagController.url(args, options),
    method: 'put',
})

export default UpdateInvoiceStatusTagController